
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit, animalType} from "../../../../../comman/config";
import Loader from "../../../../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
import * as XLSX from 'xlsx';


function List() {

    const [healthList, setHealthList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [name, setName] = useState('');
    

    const navigate = useNavigate();

    useEffect(() => {
        getHealthList();
        
    }, [page, fromDate,toDate, name]);


    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    const getHealthList = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/farm/animal/health/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
        setPopupOpen(false);
        setHealthList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const deleteHealth = async (id) => {
        try {
            await axios.delete(`${baseUrl}/admin/farm/animal/health/delete/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }

    };

   

    const editHealth = async (id) => {
        navigate(`/admin/farm/animal/health/edit/${btoa(id)}`, { state: healthList.filter(item => item.id == id) });
    }

    const handelFilterChange= (fromDate, toDate, clear, today, name) => {
        setFromDate(fromDate);
        setToDate(toDate);  
        setName(name);
    };

    const getDateList = (datelist) => {
        const dateList = JSON.parse(datelist);
        return dateList.map((val) => val).join(", ");
    }

    const exportToExcel = async () => {
        try {
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/admin/farm/animal/health/list?page=1&limit=10000&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
            const exportList = response.data.data;
            setPopupOpen(false);
    
            const data = exportList.map(item => ({
                Date: JSON.parse(item.date).join(", "),
                "Animal Type": animalType.find(val => val.value === item.animal_type)?.label ?? '',
                "Animal ID": item.animal_id,
                Description: item.description
            }));
    
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Health List");
    
            XLSX.writeFile(workbook, "Health_List.xlsx");
        } catch (error) {
            console.error('Export Error:', error);
            setPopupOpen(false);
        }
    };
    
  


    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Health List</h1>
                <div>
                <button
            onClick={exportToExcel}
            className="px-4 py-2 bg-green-700 text-white rounded-md mr-2 hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200"
        >
            Export to Excel
        </button>
                    <Link to="/admin/farm/animal/health/add">
                        <button className="px-4 py-2 bg-blue-900 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Health</button>
                    </Link>
                </div>
            </div>
            
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <DateFilter 
                handleFilterChange={handelFilterChange} 
            />
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Date</th>
                        <th scope="col" className="px-6 py-3 border">Animal Type</th>
                        <th scope="col" className="px-6 py-3 border">Animal Id</th>
                        <th scope="col" className="px-6 py-3 border">Description</th>
                        <th scope="col" className="px-6 py-3 border">Action</th>
                        </tr>
                       
                    </thead>
                    <tbody>
                    {healthList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{getDateList(item.date)}</th>
                            <td className="px-6 py-4">{animalType.find((val) => val.value ==item.animal_type)?.label ?? ""}</td>
                            <td className="px-6 py-4">{item.animal_id}</td>
                            <td className="px-6 py-4">{item.description}</td>
                           
                            <td className="px-6 py-4 flex">
                                    <a 
                                    onClick={() => editHealth(item.id)}
                                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline mr-2">
                                        <PencilIcon className="w-4 h-4 inline-block" /> {/* Edit icon */}
                                    </a>
                                    <a href="#" onClick={() => deleteHealth(item.id)} className="font-medium text-red-600 dark:text-red-500 hover:underline">
                                        <XCircleIcon className="w-4 h-4 inline-block" /> 
                                    </a>
                                </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
            {totalItem > limit && (<Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
        </div>
  );
}

export default List;